<div class="dashboard">

    <div class="header">
        <div class="title">
            <h2 mat-title>Investments</h2>
            <!-- Companies, Shares and the note reader have no card: they are not a summary of the month -->
            <a mat-icon-button routerLink="/investments/companies" title="Companies" aria-label="Companies">
                <mat-icon class="material-symbols-outlined">domain</mat-icon>
            </a>
            <a mat-icon-button routerLink="/investments/shares" title="Shares" aria-label="Shares">
                <mat-icon class="material-symbols-outlined">sell</mat-icon>
            </a>
            <a mat-icon-button routerLink="/investments/statement-reader" title="Importar nota" aria-label="Importar nota de corretagem">
                <mat-icon class="material-symbols-outlined">document_scanner</mat-icon>
            </a>
        </div>
        <app-month-picker></app-month-picker>
    </div>

    <div *ngIf="isLoading && !dashboard">Carregando...</div>

    <ng-container *ngIf="dashboard as d">
        <div class="tiles">
            <div class="tile bills">
                <span class="label">Aportes</span>
                <span class="amount">R$ {{ d.summary.totals.buys | number:'1.2-2' }}</span>
                <span class="detail">{{ d.summary.counts.buys }} compra(s) em {{ d.summary.counts.buyClasses }} classe(s), com taxas</span>
            </div>
            <div class="tile expenses">
                <span class="label">Vendas</span>
                <span class="amount">R$ {{ d.summary.totals.sells | number:'1.2-2' }}</span>
                <span class="detail">{{ d.summary.counts.sells }} venda(s)<span *ngIf="sellShares"> ({{ sellShares }})</span></span>
            </div>
            <a class="tile income" routerLink="/investments/dividends">
                <span class="label">Dividendos</span>
                <span class="amount">R$ {{ d.summary.totals.dividends | number:'1.2-2' }}</span>
                <span class="detail">{{ d.summary.dividends.length }} pagamento(s) · entram na Receita de Finances</span>
            </a>
            <div class="tile balance">
                <span class="label">Líquido investido</span>
                <span class="amount">R$ {{ d.summary.totals.net | number:'1.2-2' }}</span>
                <span class="detail">
                    Aportes − vendas
                    <ng-container *ngIf="balanceShare != null">
                        · <a routerLink="/finances">{{ balanceShare | percent:'1.0-0' }} do saldo de Finances</a>
                    </ng-container>
                </span>
            </div>
        </div>

        <div class="section-title"><h3>Telas</h3></div>
        <div class="cards">
            @for (card of d.cards; track card.title) {
                <app-dashboard-card [card]="card"></app-dashboard-card>
            }
        </div>

        <div class="charts">
            <section class="chart">
                <h4>Aportes por classe</h4>
                <span class="sub">Compras do mês, com taxas</span>
                <div class="canvas" *ngIf="byClassChart; else noData">
                    <canvas baseChart type="pie" [data]="byClassChart" [options]="pieOptions"></canvas>
                </div>
            </section>
            <section class="chart">
                <h4>Aportes e dividendos</h4>
                <span class="sub">Últimos 6 meses</span>
                <div class="canvas" *ngIf="historyChart; else noData">
                    <canvas baseChart type="bar" [data]="historyChart" [options]="barOptions"></canvas>
                </div>
            </section>
        </div>
    </ng-container>

    <ng-template #noData><p class="empty">Sem dados neste mês.</p></ng-template>
</div>
